(function () {
  var T = Number(window.sgFreeShip || 0);
  var U = window.sgUpsell || null;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function totalCents(inner) {
    var el = inner.querySelector('.totals__total-value');
    if (!el) return null;
    var n = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function handlesInCart(inner) {
    var out = {};
    inner.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var i = href.indexOf('/products/');
      if (i > -1) out[href.slice(i + 10).split(/[?#/]/)[0]] = true;
    });
    return out;
  }
  function renderBar(inner, total) {
    var old = inner.querySelector('.sg-ship');
    if (!T || inner.classList.contains('is-empty') || total === null) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-total') === String(total)) return;
    var left = T - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / T) * 100)));
    var box = old || document.createElement('div');
    box.className = 'sg-ship';
    box.setAttribute('data-total', String(total));
    box.setAttribute('role', 'status');
    box.style.cssText = 'margin:0 0 16px;font-size:14px;line-height:1.4';
    box.innerHTML = (left > 0
      ? '<p style="margin:0 0 8px">You&rsquo;re <strong>' + money(left) + '</strong> away from free US shipping.</p>'
      : '<p style="margin:0 0 8px"><strong>Free US shipping unlocked.</strong></p>') +
      '<div style="height:6px;border-radius:3px;background:rgba(255,255,255,.14);overflow:hidden"><span style="display:block;height:100%;width:' + pct + '%;background:' + (left > 0 ? '#E0281E' : '#30D158') + '"></span></div>';
    if (!old) {
      var head = inner.querySelector('.drawer__header');
      if (head && head.parentNode) head.parentNode.insertBefore(box, head.nextSibling); else inner.insertBefore(box, inner.firstChild);
    }
  }
  function pick(inner) {
    if (!U || !U.main || !U.pair) return null;
    var h = handlesInCart(inner);
    if (h[U.main.handle] && !h[U.pair.handle]) return { p: U.pair, note: U.pairNote, price: U.pair.price - (U.pairSave || 0) };
    if (!h[U.main.handle]) return { p: U.main, note: U.mainNote, price: U.main.price };
    return null;
  }
  function renderUpsell(inner) {
    var old = inner.querySelector('.sg-upsell');
    var s = inner.classList.contains('is-empty') ? null : pick(inner);
    if (!s) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-key') === s.p.handle) return;
    var box = old || document.createElement('div');
    box.className = 'sg-upsell';
    box.setAttribute('data-key', s.p.handle);
    box.style.cssText = 'display:flex;gap:12px;align-items:center;border:1px solid rgba(255,255,255,.12);border-radius:14px;padding:12px;margin:8px 0 16px';
    box.innerHTML =
      (s.p.img ? '<img src="' + esc(s.p.img) + '" alt="" width="64" height="64" style="width:64px;height:64px;object-fit:cover;border-radius:10px;background:#fff;flex:none">' : '') +
      '<div style="min-width:0;flex:1;font-size:14px;line-height:1.35"><strong style="display:block">' + esc(s.p.title) + '</strong>' +
      '<span>' + money(s.price) + (s.price < s.p.price ? ' <s style="opacity:.6">' + money(s.p.price) + '</s>' : '') + '</span>' +
      (s.note ? '<span style="display:block;opacity:.75;font-size:13px">' + esc(s.note) + '</span>' : '') + '</div>' +
      '<button type="button" class="button button--secondary" style="min-width:0;padding:0 14px;min-height:40px" data-sg-upsell-add="' + s.p.id + '">Add</button>';
    if (!old) {
      var items = inner.querySelector('cart-drawer-items');
      if (items && items.parentNode) items.parentNode.insertBefore(box, items.nextSibling); else inner.appendChild(box);
    }
  }
  function tidyDiscounts(root) {
    root.querySelectorAll('.cart-item').forEach(function (row) {
      if (row.querySelector('.cart-item__discounted-prices')) return;
      row.querySelectorAll('.discounts__discount').forEach(function (li) { li.remove(); });
    });
  }
  function render() {
    tidyDiscounts(document);
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (!inner) return;
    renderBar(inner, totalCents(inner));
    renderUpsell(inner);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sg-upsell-add]');
    if (!b) return;
    b.disabled = true;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-sg-upsell-add')), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { return r.json(); }).then(function (data) {
      var drawer = document.querySelector('cart-drawer');
      if (data && data.sections && drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(data); } else b.disabled = false;
    }).catch(function () { b.disabled = false; });
  });
  var timer;
  function init() {
    var drawer = document.querySelector('cart-drawer');
    var page = document.querySelector('cart-items');
    render();
    var mo = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(render, 50); });
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    if (page) mo.observe(page, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
